export const eventsKeys = {
  featured: () => ['events', 'featured'] as const,
  registered: () => ['events', 'registered'] as const,
  upcoming: (page: number) => ['events', 'upcoming', page] as const,
  search: (q: string, includePast: boolean, page: number) =>
    ['events', 'search', q, includePast, page] as const,
  detail: (id: string) => ['events', 'detail', id] as const,
  registrationStatus: (eventId: string) => ['events', 'registrationStatus', eventId] as const,
};
